export default __webpack_public_path__ + "static/media/no-widget.6a356c74.svg";